import {EEKGraph} from '@sdox/ui'

import type {XcNwBlock_BlockSeEekType_Fragment} from '@sdox/api'
import type {EEK} from '@sdox/ui'

export const BlockSeEek = ({co2Class}: XcNwBlock_BlockSeEekType_Fragment) => (
  <div className={'flex max-w-sm flex-50-50 flex-col gap-2 border-4 border-gray-100 p-7'}>
    <EEKGraph selectedEEK={co2Class as EEK} />
  </div>
)